{
  "badge_soon": "Soon",
  "action": {
    "collapse": "Collapse sidebar",
    "expand": "Expand sidebar"
  },
  "coming_soon_page": {
    "subtitle": "This module isn't available yet",
    "heading": "{{module}} is coming soon",
    "body": "We're still building this module. It will be available in an upcoming release. In the meantime, the Inventory and Inventory ratio modules are fully functional."
  },
  "group": {
    "operations": "Operations",
    "fulfillment": "Fulfillment",
    "integrations": "Integrations",
    "promotion": "Promotion",
    "reports": "Reports",
    "admin": "Admin"
  },
  "coming_soon": "Coming soon",
  "item": {
    "dashboard": "Dashboard",
    "orders": "Orders",
    "inventory": "Inventory",
    "inventory_diff": "Inventory diff",
    "inventory_ratio": "Inventory ratio",
    "sku_brands": "SKU brands",
    "campaign": "Campaign",
    "promotion": "Promotion",
    "promotion_report": "Promotion report",
    "inbound_report": "Inbound report",
    "revenue_report": "Revenue report",
    "export_orders": "Export orders",
    "orders_export": "Orders Export",
    "split": "Split Orders",
    "returns": "Returns",
    "users": "Users",
    "audit_log": "Audit log",
    "marketplace_connections": "Marketplace connections",
    "manual_review": "Manual review",
    "notifications": "Notifications",
    "notifications_unread": "unread notifications"
  },
  "badge_attention": "{{n}} orders need attention"
}
